import { Component, inject, OnInit, Input, ChangeDetectorRef, OnChanges, SimpleChanges, Pipe, PipeTransform } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap/modal';
import { FormsModule } from '@angular/forms';
import { AddressEdit } from "../Controlls/AddressEdit"
import { DateSelect } from "../Controlls/DateSelect"
import { Notfallplan } from '../../Api/DcoApi/Notfallplan';
import { RestClient } from '../../Api/DcoApi/Client/RestClient';
import { Kontackt } from '../../Api/DcoApi/Kontackt';
import { Address } from '../../Api/DcoApi/Address';
import { Auftrag } from '../../Api/DcoApi/Auftraege';
import { Artikel, Artikeleintrag } from '../../Api/DcoApi/AktenEintraege/Artikel';

@Pipe({
  name: 'excludeUsed',
  standalone: true
})
export class ExcludeUsedPipe implements PipeTransform {
  transform(items: Artikel[], usedItems: Artikel[] | null): Artikel[] {
    if (!items || !usedItems || usedItems == null) return items;

    // Behalte Items, die nicht in usedItems sind ODER das aktuell gewählte Item selbst
    return items.filter(item =>
      !usedItems.some(used => used.key === item.key)
    );
  }
}

@Component({
  imports: [
    FormsModule, AddressEdit, DateSelect
  ],
  selector: 'ArtikelEdit',
  templateUrl: './ArtikelEdit.html',
  standalone: true,
  styleUrl: './ArtikelEdit.css'
})
export class ArtikelEdit implements OnChanges {
  constructor(private cdr: ChangeDetectorRef) { this.LoadPlan(); }
  ngOnChanges(changes: SimpleChanges): void {
    this.LoadPlan();
    
  }
  ngOnInit(): void {
    this.LoadPlan();
  }

  get FilterArtikelList(): Artikel[]  {

    if (this.ArtikelList == null)
      return [];

    if (!this.Auftrag || this.Auftrag == null || this.Auftrag.auftragArtikel == null)
      return this.ArtikelList;
    else {
      // Behalte Items, die nicht in usedItems sind ODER das aktuell gewählte Item selbst
      return this.ArtikelList.filter(item =>
        !this.Auftrag || (this.Auftrag?.auftragArtikel == null) || !(this.Auftrag.auftragArtikel.some(used => used.artikel.key === item.key))
      );
    }
  }

  modal = inject(NgbActiveModal);
  ArtikelList: Artikel[] | null = null;
  SelectedArtikel: Artikel | null = null;
  EditKontakte: Kontackt | null = null;
  anzahl: number = 1;
  Client: RestClient = new RestClient();

  onValueChange(newValue: any) {
    this.SelectedArtikel = newValue;
  }

  async LoadPlan() {
    this.ArtikelList = await this.Client.Get<Artikel[]>(`/Backend/Api/V2/Artikel`) ?? {} as Artikel[];
    this.cdr.detectChanges();
  }

  get UsedArtikel(): Artikel[] {
    if (this.Auftrag == null || this.Auftrag.auftragArtikel == null || this.Auftrag.auftragArtikel == undefined)
      return [];

    return this.Auftrag.auftragArtikel.map(o => o.artikel);
  }

  async DeleteEntry(artnr: string) {
    if (this.Auftrag != null) {
      await this.Client.Delete(`/Backend/Api/V2/Akte/${this.VersichertenNR}/Patient/Kontakt/${this.Auftrag.key}/Delete`);
      this.cdr.detectChanges();
    }
  }

  async SaveEntry() {
    if (this.Auftrag != null) {
      this.Auftrag.auftragArtikel = await this.Client.Post<Artikeleintrag[], Artikeleintrag>(`/Backend/Api/V2/Akte/${this.VersichertenNR}/Auftrag/${this.Auftrag.key}/Artikel`, {
        anzahl: this.anzahl, artikel: this.SelectedArtikel
        } as Artikeleintrag);
      this.cdr.detectChanges();
    }
  }


  compareFn(obj1: Artikel, obj2: Artikel): boolean {
    return obj1 && obj2 ? obj1.key === obj2.key : obj1 === obj2;
  }

  @Input() VersichertenNR: string | null = null;
  @Input() Auftrag: Auftrag | null = null;
}
